import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _defineProperty from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import TeDialog from 'src/components/Dialogs/TEDialog';
import EntityPicker from 'src/components/Pickers/Picker';
import { dialog } from 'src/boot/mixins.js'; // import TimeInput from 'src/components/Pickers/TimeInput'

import WorkspaceAccessLevel from 'src/components/Pickers/WorkspaceAccessLevel';
import SubscriptionTypeUpgrade from 'src/components/SubscriptionTypeUpgrade';
export default {
  mixins: [dialog],
  components: {
    TeDialog: TeDialog,
    EntityPicker: EntityPicker,
    // TimeInput,
    WorkspaceAccessLevel: WorkspaceAccessLevel,
    SubscriptionTypeUpgrade: SubscriptionTypeUpgrade
  },
  data: function data() {
    return {
      userData: {
        workspace_access_level: null,
        group_id: null,
        project_ids: [],
        manager_id: null,
        // -1 for not assigned, null for leave unchanged
        user_hourly_rate: null,
        user_hourly_cost: null,
        working_time: null
      }
    };
  },
  methods: {
    save: function save() {
      var userData = _objectSpread({}, this.userData);

      if (userData.manager_id === null) {
        delete userData.manager_id;
      } else if (userData.manager_id === -1) {
        userData.manager_id = null;
      }

      this.onOKClick(userData);
    }
  }
};